import React from "react"
import PropTypes from "prop-types"

import {
  StyledImageGrid,
  StyledImageContainer,
  StyledImg,
} from "./DesktopImages.styles"

const DesktopImages = ({ images, handleOpenModal, projectName }) => {
  if (images.length >= 4) {
    return (
      <StyledImageGrid>
        {images.map((image, idx) => (
          <StyledImageContainer
            as="button"
            type="button"
            style={{ padding: 0, border: 0, background: "transparent" }}
            aria-label={`View ${projectName} photograph ${idx + 1}`}
            key={image.id}
            onClick={() => handleOpenModal(idx)}
          >
            <StyledImg
              src={image.image}
              alt={`${projectName}, photograph ${idx + 1}`}
            />
          </StyledImageContainer>
        ))}
      </StyledImageGrid>
    )
  }
  return (
    <StyledImageContainer>
      <StyledImg src={images[0].image} alt={`${projectName}, photograph 1`} />
    </StyledImageContainer>
  )
}

DesktopImages.propTypes = {
  projectName: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      bannerPosition: PropTypes.string,
      image: PropTypes.oneOfType([
        PropTypes.shape({
          original: PropTypes.string,
          large: PropTypes.string,
          medium: PropTypes.string,
          small: PropTypes.string,
        }),
        PropTypes.string,
      ]),
      id: PropTypes.string,
    })
  ).isRequired,
  handleOpenModal: PropTypes.func.isRequired,
}

export default DesktopImages
